import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AdminProductsService } from "../../../pages/admin-pages/products/services/admin-products.service";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { FailState } from "../../models/fail-state";
import { MonitoringTiersState } from "../../models/mp-admin/monitoring-tiers-state";
import { AppState } from "../../reducers";
import { AdminProductsSelectors } from "../../selectors/admin-products.selectors";

@Injectable()
export class MonitoringTiersEffects {
	monitoringTiers = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.monitoringTiers.get),
			withLatestFrom(this.store.select(AdminProductsSelectors.monitoringTiers)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(AdminProductsActions.monitoringTiers.getSuccess({ state }))
					: of(AdminProductsActions.monitoringTiers.getApi())
			)
		)
	);

	monitoringTiersApi = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.monitoringTiers.getApi),
			switchMap(() =>
				this.service.getMonitoringTiers().pipe(
					map((tiers) =>
						AdminProductsActions.monitoringTiers.getSuccess({
							state: { tiers, loading: false, hasLoaded: true }
						})
					),
					catchError((error) =>
						of(AdminProductsActions.monitoringTiers.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private service: AdminProductsService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: MonitoringTiersState): boolean {
		return (
			state !== undefined &&
			!_.has(state, "error") &&
			!state.loading &&
			state.hasLoaded === true &&
			_.has(state, "tiers") &&
			state.tiers !== undefined
		);
	}
}
